import React, { useState } from "react";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DashboardLeftMenu from "../DashboardLeftMenu";
import DashboardHeader from "../../Header/DashboardHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import Axios from "../../../axios/Axios";
import Spining from "../../UI/Spining/Spining";
import { handleUserLog } from "../../Utils/Utils";

const CtaReport = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const date = new Date();

    const [error, setError] = useState({
        errorStatus: false,
        errorMessage: "",
        bgColor: "",
    });
    const [startDate, setStartDate] = useState(date);
    const [endDate, setEndDate] = useState(date);
    const [channel, setChannel] = useState("");
    const [urlDataReport, setUrlDataReport] = useState([]);
    const [submitVia, setSubmitVia] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [disable, setDisable] = useState(false)

    const addDays = (date, days) => {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    };

    const onChange = (e) => {
        setChannel(e.target.value);
        setError({ errorStatus: false });
    };

    const isValid = () => {
        if (channel === undefined || channel === "") {
            setError({
                errorStatus: true,
                errorMessage: "Please Select Channel",
                bgColor: "alert alert-danger",
            });
            return false;
        }
        if (submitVia === undefined || submitVia === "") {
            setError({
                errorStatus: true,
                errorMessage: "Please Select Submit Via",
                bgColor: "alert alert-danger",
            });
            return false;
        } else {
            return true;
        }
    };


    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const urlDetails = async () => {
        if (isValid()) {
            const formattedStartDate = formatDate(startDate);
            const formattedEndDate = formatDate(endDate);

            const paramData = {
                user_id: userId,
                token: userToken,
                fromdate: formattedStartDate,
                todate: formattedEndDate,
                submit_via: submitVia === "pannel" ? "PANNEL" : "API",
                method: submitVia === "api" ? "api_quickreply_summary" : "camp_quickreply_summary"
            };

            try {
                let { data } = await Axios.post(`${NODE_HOST_URL_v1}/click_reply`, paramData);
                setDisable(true)
                if (data.success) {
                    let filterData = data.data.filter(x => x.total_count !== 0)
                    setUrlDataReport(filterData);
                    setDisable(false)
                }
                else {
                    setDisable(false)
                }
            } catch (error) {
                console.log(error);
                setDisable(false)
            }
            // Code to fetch URL data report (commented out)
        }
    };


    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const sendData = (short_url) => {
        const url = `/dashboard/fixed-url-report/${channel}/${currentDate(startDate)}/${currentDate(endDate)}/${encodeURIComponent(short_url)}`;
        window.open(url, "_blank");
    };


    // const handleDownload = async () => {
    //     try {
    //         const payload = {
    //             user_id: userId,
    //             token: userToken,
    //             fromdate: currentDate(startDate),
    //             todate: currentDate(endDate),
    //             submit_via: submitVia === 'api' ? 'API' : 'PANNEL',
    //             method: submitVia === 'api' ? 'api_summary_download' : 'camp_summary_download'
    //         };

    //         // 👇 request binary data instead of JSON
    //         const response = await Axios.post(`${NODE_HOST_URL_v1}/click_reply`, payload, {
    //             responseType: 'arraybuffer'
    //         });

    //         // Convert binary data to blob
    //         const blob = new Blob([response.data], { type: "application/octet-stream" });

    //         // Create download link
    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement("a");
    //         link.href = url;

    //         // set file name
    //         link.setAttribute("download", "report.xlsx"); // or .csv / .zip depending on server file

    //         document.body.appendChild(link);
    //         link.click();

    //         // cleanup
    //         link.remove();
    //         window.URL.revokeObjectURL(url);

    //     } catch (error) {
    //         console.error(error);
    //         setError({
    //             errorStatus: true,
    //             errorMessage: error?.response?.data?.message || 'Unable to download, please try again later',
    //             bgColor: "alert alert-danger",
    //         });
    //     }
    // };

    const handleDownload = async () => {
    try {
        const payload = {
            user_id: userId,
            token: userToken,
            fromdate: currentDate(startDate),
            todate: currentDate(endDate),
            submit_via: submitVia === 'api' ? 'API' : 'PANNEL',
            method: submitVia === 'api' ? 'api_summary_download' : 'camp_summary_download'
        };

        const response = await Axios.post(`${NODE_HOST_URL_v1}/click_reply`, payload, {
            responseType: 'arraybuffer'
        });

        const blob = new Blob([response.data], {
            type: "application/octet-stream"
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", "report.xlsx");

        document.body.appendChild(link);
        link.click();

        // Log successful download
        handleUserLog(
            "",
            "download_cta_button_report",
            "cta_button_report",
            "CTA report downloaded successfully",
           "cta_button_report",
            "",
            {
                fromdate: payload.fromdate,
                todate: payload.todate,
                submit_via: payload.submit_via,
                method: payload.method
            }
        );

        link.remove();
        window.URL.revokeObjectURL(url);

    } catch (error) {

        console.error(error);

        // Log failed download
        handleUserLog(
            "",
            "download_cta_button_report_error",
            "cta_button_report",
            error?.response?.data?.message || "Unable to download CTA report",
            "cta_button_report",
            "",
            {
                fromdate: currentDate(startDate),
                todate: currentDate(endDate),
                submit_via: submitVia === 'api' ? 'API' : 'PANNEL',
                method: submitVia === 'api'
                    ? 'api_summary_download'
                    : 'camp_summary_download'
            }
        );

        setError({
            errorStatus: true,
            errorMessage: error?.response?.data?.message || 'Unable to download, please try again later',
            bgColor: "alert alert-danger",
        });
    }
};



    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="card">
                        {isLoading && <Spining />}
                        <div className="card-body">
                            <div className="container-fluid p-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        {error.errorStatus && (
                                            <div className={error.bgColor} role="alert">
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="alert"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <div>{error.errorMessage}</div>
                                            </div>
                                        )}
                                        <h5 className="card-title">CTA Report</h5>
                                        <form className="row mb-4">
                                            <div className="col-md-3">
                                                <label>Select Channel</label>
                                                <select
                                                    className="form-control"
                                                    name="channel"
                                                    value={channel}
                                                    onChange={onChange}
                                                >
                                                    <option value="">Select Channel</option>
                                                    <option value="whatsapp">Whatsapp</option>
                                                    {/* <option value="sms">Sms</option>
                            <option value="rcs">Rcs</option> */}
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label className="d-block">From Date</label>
                                                <ReactDatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={startDate}
                                                    className="form-control"
                                                    onChange={(date) => setStartDate(date)}
                                                    selectsStart
                                                    startDate={startDate}
                                                />
                                            </div>

                                            <div className="col-12 col-md-3">
                                                <label className="d-block">To Date</label>
                                                <ReactDatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    selectsEnd
                                                // startDate={startDate}
                                                // minDate={startDate}
                                                // maxDate={addDays(startDate, 30)}
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label>Submit Via</label>
                                                <select
                                                    className="form-control"
                                                    name="submitVia"
                                                    value={submitVia}
                                                    onChange={(e) => setSubmitVia(e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="pannel">Pannel</option>
                                                    <option value="api">API</option>
                                                </select>
                                            </div>
                                        </form>

                                        <div className="d-flex justify-content-center mb-3">
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={urlDetails}
                                                disabled={disable ? true : false}
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    {urlDataReport.length > 0 ? (
                                        <>
                                            <div className="row">
                                                <div className="col-6"></div>
                                                <div className="col-6">
                                                    {/* <a
                                                        type="button"
                                                        className="btn btn-warning float-right mb-2"
                                                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: "45px", color: "white" }}
                                                        href={submitVia === 'api' ? `${NODE_HOST_URL_v1}/click_reply?user_id=${userId}&token=${userToken}&fromdate=${currentDate(startDate)}&todate=${currentDate(endDate)}&submit_via=API&method=api_summary_download`
                                                            : `${NODE_HOST_URL_v1}/click_reply?user_id=${userId}&token=${userToken}&fromdate=${currentDate(startDate)}&todate=${currentDate(endDate)}&submit_via=PANNEL&method=camp_summary_download`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a> */}

                                                    <button className="btn btn-warning float-right mb-2" onClick={handleDownload}>Download</button>

                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-striped table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th><span>Campaign ID</span></th>
                                                            {submitVia === "pannel" && <th><span>Button Name</span></th>}
                                                            <th><span>Click Count</span></th>
                                                            <th><span>Action</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {urlDataReport.map((item, i) => (
                                                            <tr key={i}>
                                                                <td>{item.camp_id}</td>
                                                                {submitVia === "pannel" && <td>{item.btn_name}</td>}
                                                                <td>{item.total_count}</td>
                                                                <td>
                                                                    <a href={`/dashboard/cta-detail-report/${startDate}/${endDate}/${submitVia}/${item.camp_id}/${item.btn_name}`} target="_blank" rel="noopener noreferrer">
                                                                        <FontAwesomeIcon
                                                                            icon={faEye}
                                                                            style={{ color: "blue", cursor: "pointer" }}
                                                                        />
                                                                    </a>
                                                                </td>
                                                            </tr>

                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>  </>
                                    ) :
                                        //   urlDataReport.length > 0 && submitVia === "api" ? (
                                        //     <div className="table-responsive">
                                        //       <table className="table table-striped table-sm">
                                        //         <thead>
                                        //           <tr>
                                        //             <th>Date</th>
                                        //             <th>Total Count</th>
                                        //           </tr>
                                        //         </thead>
                                        //         <tbody>
                                        //           {urlDataReport.map((item, i) => (
                                        //             <tr key={i}>
                                        //               <td>{item.date}</td>
                                        //               <td>{item.total_count}</td>
                                        //             </tr>
                                        //           ))}
                                        //         </tbody>
                                        //       </table>
                                        //     </div>) : 
                                        (
                                            <div className="text-center">
                                                <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                <p>Data Not Found</p>
                                            </div>
                                        )
                                    }



                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default CtaReport;
